import React, { useEffect } from 'react';
import styled from "@emotion/styled/macro";

import {useVscContext} from "../../content/VscReactContext";
import {useVisualizerSession} from "../../visualizer/VscVisualizerSession";

const AmenityMapIframe = styled.iframe`
  height: 100%;
  width:100%;
  border: 0;
 
`

const PreloadAmenityMap: React.FC<{id:string, theme:string}> = (props) => {
    return null;
}

const InterActiveCommunityMap: React.FC<{id:string, theme:string}> = (props) => {

    const { id, theme } = props;
    const vscContext = useVscContext();
    const visSession = useVisualizerSession();

    useEffect(() => {
        visSession.clearStatus();
    }, [id, theme]);
    const serverUri = vscContext.serverUri + "UnrealEmulator";
    let src = "https://on2-amenity-map.bimaire.app/?SaleCenterId=" + id + "#unrealUrl=" + encodeURIComponent(serverUri);
    return (<AmenityMapIframe src={src} ></AmenityMapIframe>);
}

export default InterActiveCommunityMap;
